import React, {useState} from "react"
import nprogress from "nprogress"
import useAuth from "auth/useAuth"
import "./Membership.css"
import {getCurrentSeason} from "utils/date_utils"

export default function Membership() {

    const {auth, API} = useAuth()
    const [ids, setIds] = useState("")
    const [season, setSeason] = useState(getCurrentSeason())
    const [success, setSuccess] = useState()
    const [errors, setErrors] = useState()

    const paid = () => {
        nprogress.start()        
        auth(API.adminMembershipsPost, {season}, JSON.stringify(ids)).then(response => {
            setSuccess(response.data.success)
            setErrors(response.data.errors)
            nprogress.done()
        }).catch(response => {
            nprogress.done()
            console.log(response)
        })
    }

    
    return <section id="membership">
        <h3>Godišnja članarina</h3>
        <p>
            Upiši GSS brojeve spasilaca koji su platili članarinu.<br/>
            Brojeve možeš razdvojiti zarezom, razmakom ili novim redom.<br/>
            Spasioci koji su već označeni kao da su platili članarinu neće biti izbrisani, tako da ih nije potrebno unositi sve odjednom.
        </p>
        
        <input type="number" value={season} onChange={e => setSeason(e.target.value)} placeholder="Godina..."/>
        <textarea placeholder="Brojevi spasilaca koji su platili članarinu, odvojeni zarezom, razmakom ili novim redom..." value={ids} onChange={e => setIds(e.target.value)}/>
        <button className="btn btn-primary" onClick={paid}>Snimi</button>
        
                
        {success && <div className="response">
            <br/>
            Uspešno upisano članarina: {success.length}
        </div>}
        
        {errors && errors.length > 0 && <div className="response">
            Greške: {errors.join(", ")}
        </div>}
        
    </section>
}